<h3 class="title">Scheduling Conflict Exists</h3>
<br>  

<div>{{ textContent }}</div>
<br>

<div class="action-buttons">
  <nv-button type="secondary" (click)="cancel()">CANCEL</nv-button>
  <nv-button type="secondary" (click)="confirm()">CONFIRM</nv-button>
</div>